import React, { useState, useEffect } from "react";
import {
  Button,
  Layout,
  Typography,
  Input,
  Spin,
  Divider,
  Pagination,
  Flex,
  Badge,
  Popover,
  List,
  Tag,
  Row,
  Col,
  Tooltip,
} from "antd";
import {
  selectNotificationsData,
  selectTotalUnreadCount,
} from "../../redux/slices/notificationsSlice";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  SearchOutlined,
  BellOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./layout.module.css";
import {
  toggleSidebarCollapsed,
  toggleSidebarDrawer,
} from "../../redux/slices/uiSlice";
import getPageTitle from "../../routes/routeTitles";
import { routeTitles } from "../../routes/routeTitles";
import axiosInstance from "../../services/axiosInstance";
import SearchDescriptionsList from "../SearchDescriptionsList";
import { useMediaQuery } from "react-responsive";
import { PlusIcon } from "lucide-react";
import GloballyForms from "../../page-components/GloballyForms/GloballyForms";
import commonService from "../../services/commonService";
import { message } from "antd";
import { updateMetaTags } from "../../utils/metaTags";
const { Header } = Layout;
const { Title } = Typography;

const HeaderContent = ({ isAuthenticated }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const notificationCount = 5;
  // State

  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResult, setSearchResult] = useState({ clients: [], tasks: [] });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const totalUnreadCount = useSelector(selectTotalUnreadCount);
  const notificationsData = useSelector(selectNotificationsData);
  const notificationOrder = [
    "urgent",
    "high_priority",
    "feedbacks",
    "resolved",
    "info",
  ];

  const isEmailVerified = useSelector(
    (state) => state.notifications.isEmailVerified
  );
  console.log("isEmailVerified from header:", isEmailVerified);
  // const isEmailVerified = useSelector((state) => state.commonInfo.is_email_verified);
  // console.log("isEmailVerified:", isEmailVerified);
  // Sort notificationsData based on the defined order

  const sortedNotificationsData = notificationsData.slice().sort((a, b) => {
    return (
      notificationOrder.indexOf(a.level) - notificationOrder.indexOf(b.level)
    );
  });
  // Verify state values
  // useEffect(() => {
  //   console.log("Total Unread Count:", totalUnreadCount); // Log total unread count
  //   console.log("Notifications Data:", notificationsData); // Log notifications data
  // }, [totalUnreadCount, notificationsData]);

  // Get notifications data from Redux
  // Get total unread count from Redux
  // const notifications = useSelector(selectNotificationsData);
  // Redux state
  const { collapsed, drawerOpen } = useSelector((state) => ({
    collapsed: state.ui.collapsed,
    drawerOpen: state.ui.drawerOpen,
  }));

  const currentPath = location.pathname;
  const pageTitle = getPageTitle(currentPath, routeTitles);

  // Update document title and meta tags on route change
  useEffect(() => {
    if (pageTitle) {
      updateMetaTags({
        title: `${pageTitle.trim()} - LocusRags`,
        description: `${pageTitle.trim()} - LocusRags Order Management`,
      });
    }
  }, [pageTitle, location.pathname]);
  const [popoverVisible, setPopoverVisible] = useState(false); // State to control Popover visibility
  // Reset search when navigating away from search page
  useEffect(() => {
    if (!currentPath.includes("search=true")) {
      setSearchQuery("");
      setSearchResult({ clients: [], tasks: [] });
      setSearched(false);
      setLoading(false);
    }
  }, [currentPath]);

  // Cleanup loading state when component unmounts
  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);
  const handleResendEmail = async () => {
    const response = await commonService.resentEmailVerification();
    if (response.success) {
      message.success("Email sent successfully");
    } else {
      message.error("Failed to send email");
    }
  };
  const handleSearch = async (page = 1, pageSize = 10) => {
    if (!searchQuery.trim()) return;

    setLoading(true);
  setSearched(true);

    const validPage = Number.isInteger(page) && page > 0 ? page : 1;
    const validPageSize =
      Number.isInteger(pageSize) && pageSize > 0 ? pageSize : 10;

    // Navigate to search page
    navigate(
      `/search=true?query=${encodeURIComponent(
        searchQuery
      )}&page=${validPage}&pageSize=${validPageSize}`
    );

    try {
      const response = await axiosInstance.get(
        `/task/v2/global-search/?search=${encodeURIComponent(
          searchQuery
        )}&page=${validPage}&pageSize=${validPageSize}`
      );

      if (response?.data?.data) {
        const { data } = response.data;
        setSearchResult(data);

        // Update pagination based on tasks count
        setPagination((prev) => ({
          ...prev,
          current: validPage,
          pageSize: validPageSize,
          total: data.tasks?.count || 0,
        }));
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
      setSearchResult({ clients: [], tasks: [] });
    } finally {
      setLoading(false);
    }
  };
  const handlePageChange = (page, pageSize) => {
    handleSearch(page, pageSize);
  };

  if (!isAuthenticated) return null;
  const handleNotificationClick = (item) => {
    setPopoverVisible(false);
    // Directly pass the level as is without formatting
    navigate(`/notifications?level=${encodeURIComponent(item.level)}`);
  };

  const renderSearchResults = () => {
    if (!searched) return null;

    return (
      <>
        {loading ? (
          <Flex style={{ width: "100%" }} align="center" justify="center">
            <Spin size="large" />
          </Flex>
        ) : (
          <div
            style={{
              maxHeight: "100%",
              overflowY: "scroll",

              background: "#f2f6f9 ",

              // minHeight: "30%",
              padding: 14,
            }}
          >
            {/* Clients Section */}
            {Array.isArray(searchResult?.clients) &&
              searchResult.clients.length > 0 && (
                <>
                  <Title level={4}>Clients</Title>
                  <SearchDescriptionsList
                    items={searchResult.clients}
                    type="client"
                  />
                  <Divider />
                </>
              )}

            {/* Tasks Section */}
            {Array.isArray(searchResult?.tasks?.results) &&
              searchResult.tasks.results.length > 0 && (
                <>
                  <Title level={4}>Orders</Title>
                  <SearchDescriptionsList
                    items={searchResult.tasks.results}
                    type="task"
                  />
                  <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    onChange={handlePageChange}
                    className={styles.pagination}
                  />
                </>
              )}

            {/* No Results Message */}
            {searched &&
              !loading &&
              !searchResult?.clients?.length &&
              !searchResult?.tasks?.results?.length && (
                <p className={styles.noResults}>
                  No data found for your search.
                </p>
              )}
          </div>
        )}
      </>
    );
  };
  // Notification Popover content
  const formatLevel = (level) => {
    // Replace underscores with spaces and capitalize the first letter of each word
    return level
      .split("_")
      .map((word, index) => {
        if (index === 0) {
          return word.charAt(0).toUpperCase() + word.slice(1); // Capitalize the first word
        }
        return word.charAt(0).toUpperCase() + word.slice(1); // Capitalize subsequent words
      })
      .join(" "); // Join them back together
  };

  const notificationPopoverTitle = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span>Notifications</span>
      <Tooltip title="Click a tab to view notifications">
        <InfoCircleOutlined
          style={{ marginLeft: 8, cursor: "pointer", color: "#555" }}
        />
      </Tooltip>
    </div>
  );
  const notificationContent = (
    <div>
      {sortedNotificationsData.map((item, index) => {
        // Define color mapping for levels
        const levelColorMapping = {
          urgent: "#f87171", // red
          high_priority: "#fdba74", // orange
          feedbacks: "#93c5fd", // blue
          resolved: "#d8b4fe", // purple
          info: "#cbd5e1", // gray
        };

        // Get the color for the current level, default to gray if not found
        const tagColor = levelColorMapping[item.level] || "#cbd5e1";

        return (
          <Flex key={item.level} vertical gap={4}>
            <a
              href={`/notifications?level=${encodeURIComponent(item.level)}`}
              onClick={(e) => {
                // Only handle left click without modifier keys for in-app navigation
                if (
                  !e.ctrlKey &&
                  !e.metaKey &&
                  !e.shiftKey &&
                  !e.altKey &&
                  e.button === 0
                ) {
                  e.preventDefault();
                  handleNotificationClick(item);
                }
                // Otherwise, let the default browser behavior happen (open in new tab, etc.)
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                background: tagColor,
                padding: "2px 8px",
                borderRadius: "4px",
                marginTop: 4,
                cursor: "pointer",
                border: "transparent",
                textDecoration: "none",
                color: "inherit",
                width: "90%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div>{formatLevel(item.level)}</div>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  {item.count}
                </div>
              </div>
            </a>
          </Flex>
          // <List.Item
          //   key={index}
          //   style={{
          //     padding: 8,
          //     cursor: "pointer",
          //     // borderBottom: "1px solid #ddd",
          //   }}
          //   onClick={() => handleNotificationClick(item)}>
          //   <Tag color={tagColor}>
          //     {`${formatLevel(item.level)} - ${item.count}`}
          //   </Tag>
          // </List.Item>
        );
      })}
    </div>
  );

  return (
    <>
      <Header className={styles.global_header}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => dispatch(toggleSidebarCollapsed())}
            className={styles.header_btn}
          />
          <Button
            type="text"
            icon={drawerOpen ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => dispatch(toggleSidebarDrawer())}
            className={styles.mobile_toggle}
          />
          {/* <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => dispatch({ type: "TOGGLE_SIDEBAR" })}
            className={styles.header_btn}
          /> */}
          <Title level={isMobile ? 4 : 2} style={{ margin: 0 }}>
            {pageTitle}
          </Title>
        </div>

        <Flex align="center" gap={10}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Popover
              style={{ maxWidth: 70 }}
              content={notificationContent}
              title={notificationPopoverTitle}
              trigger="click"
              placement="bottomRight"
              visible={popoverVisible} // Controlled visibility
              onVisibleChange={(visible) => setPopoverVisible(visible)}
            >
              <Badge
                count={totalUnreadCount}
                offset={isMobile ? [-12, 6] : [-12, 6]}
              >
                <Button
                  type="text"
                  icon={<BellOutlined style={{ fontSize: 20 }} />}
                  // className={styles.header_btn}
                />
              </Badge>
            </Popover>
          </div>
          {/* <div style={{ display: "flex", alignItems: "center"  ,padding:'10px'}}>
        <Badge count={notificationCount} offset={[-20, 20]}>
          <Button
            type="text"
            onClick={handleNotificationClick}
            icon={<BellOutlined style={{ fontSize: 20 }} />}
            className={styles.header_btn}
          />
        </Badge>
      </div> */}
          <Input.Search
            placeholder="Search..."
            onSearch={() => handleSearch(1, pagination.pageSize)}
            onChange={(e) => setSearchQuery(e.target.value)}
            value={searchQuery}
            style={{ width: isMobile ? 100 : 300, marginRight: "10px" }}
            enterButton={
              <Button type="primary" style={{ backgroundColor: "#040724" }}>
                <SearchOutlined />
              </Button>
            }
          />
          <GloballyForms />
        </Flex>
      </Header>

      {console.log(isEmailVerified, "isEmailVerified")}
      {isEmailVerified !== undefined && !isEmailVerified && (
        <>
          <Divider style={{ margin: 0 }} />
          <div
            className="marquee"
            style={{
              background: "#FFF1F0",
              color: "#990000",
              padding: "8px 0",
              textAlign: "center",
              fontWeight: "500",
            }}
          >
            <span>
              Please verify your email today to continue using your account.
              Didn't receive the mail?{" "}
              <Button
                style={{ padding: 0 }}
                onClick={handleResendEmail}
                type="link"
              >
                Click here to resend
              </Button>{" "}
              For queries, contact abhishek.sharma@zucol.in
            </span>
          </div>
        </>
      )}
      {renderSearchResults()}
    </>
  );
};

export default HeaderContent;
